/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sessions_Not_NotificationsInputs */

const th_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นี่คือที่ที่บัญชีของคุณเข้าสู่ระบบ ไม่ใช่ที่ที่ส่งการแจ้งเตือน:`)
};

const en_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is where your account is signed in, not where notifications are delivered:`)
};

const ja_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これはアカウントがログイン中の端末で、通知の配信先ではありません:`)
};

const zh_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是你的账户登录的位置——不是通知发送到的地方：`)
};

const es_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquí es donde tienes la sesión iniciada, no dónde se entregan las notificaciones:`)
};

const pt_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É aqui que sua conta está conectada, não onde as notificações são entregues:`)
};

const id_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di sini akun Anda sedang masuk — bukan ke mana notifikasi dikirim:`)
};

const fr_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voici où votre compte est connecté, pas où les notifications sont remises :`)
};

const tl_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dito naka-sign in ang account mo — hindi kung saan napupunta ang mga notipikasyon:`)
};

const vi_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đây là nơi tài khoản bạn đang đăng nhập — không phải nơi thông báo được gửi tới:`)
};

const ko_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정이 로그인되어 있는 곳입니다. 알림이 가는 곳과는 다릅니다:`)
};

const de_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier ist dein Konto angemeldet — nicht, wohin Benachrichtigungen gehen:`)
};

const ru_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здесь выполнен вход в ваш аккаунт — а не туда приходят уведомления:`)
};

const tr_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabınız buralarda açık — bildirimlerin gittiği yer değil:`)
};

const it_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qui il tuo account ha una sessione aperta, non è dove arrivano le notifiche:`)
};

const pl_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutaj twoje konto jest zalogowane — a nie tu trafiają powiadomienia:`)
};

const uk_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тут ваш обліковий запис має відкриту сесію — а не туди надходять сповіщення:`)
};

const hi_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यहाँ आपका खाता साइन इन है — यह नहीं कि सूचनाएँ कहाँ जाती हैं:`)
};

const ar_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنا سجّل حسابك الدخول — لا إلى هنا تذهب الإشعارات:`)
};

const ms_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di sini akaun anda log masuk — bukan ke mana pemberitahuan pergi:`)
};

const bn_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখানে আপনার অ্যাকাউন্ট সাইন ইন আছে — বিজ্ঞপ্তি এখানে যায় না:`)
};

const zh_tw2_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這是你的帳戶登入的位置——不是通知送達的地方：`)
};

const zh_hk2_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這是你的帳戶登入的位置——不是通知送達的地方：`)
};

const ur_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہاں آپ کا اکاؤنٹ سائن اِن ہے — اطلاعات یہاں نہیں جاتیں:`)
};

const fa_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حساب شما اینجا وارد شده است — اعلان‌ها به اینجا نمی‌روند:`)
};

const sw_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapa ndipo akaunti yako imeingia — si mahali arifa zinapokwenda:`)
};

const nl_sessions_not_notifications = /** @type {(inputs: Sessions_Not_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier is je account ingelogd — niet waar meldingen heen gaan:`)
};

/**
* | output |
* | --- |
* | "This is where your account is signed in, not where notifications are delivered:" |
*
* @param {Sessions_Not_NotificationsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sessions_not_notifications = /** @type {((inputs?: Sessions_Not_NotificationsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessions_Not_NotificationsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sessions_not_notifications(inputs)
	if (locale === "ja") return ja_sessions_not_notifications(inputs)
	if (locale === "zh") return zh_sessions_not_notifications(inputs)
	if (locale === "es") return es_sessions_not_notifications(inputs)
	if (locale === "pt") return pt_sessions_not_notifications(inputs)
	if (locale === "id") return id_sessions_not_notifications(inputs)
	if (locale === "fr") return fr_sessions_not_notifications(inputs)
	if (locale === "tl") return tl_sessions_not_notifications(inputs)
	if (locale === "vi") return vi_sessions_not_notifications(inputs)
	if (locale === "ko") return ko_sessions_not_notifications(inputs)
	if (locale === "de") return de_sessions_not_notifications(inputs)
	if (locale === "ru") return ru_sessions_not_notifications(inputs)
	if (locale === "tr") return tr_sessions_not_notifications(inputs)
	if (locale === "it") return it_sessions_not_notifications(inputs)
	if (locale === "pl") return pl_sessions_not_notifications(inputs)
	if (locale === "uk") return uk_sessions_not_notifications(inputs)
	if (locale === "hi") return hi_sessions_not_notifications(inputs)
	if (locale === "ar") return ar_sessions_not_notifications(inputs)
	if (locale === "ms") return ms_sessions_not_notifications(inputs)
	if (locale === "bn") return bn_sessions_not_notifications(inputs)
	if (locale === "zh-TW") return zh_tw2_sessions_not_notifications(inputs)
	if (locale === "zh-HK") return zh_hk2_sessions_not_notifications(inputs)
	if (locale === "ur") return ur_sessions_not_notifications(inputs)
	if (locale === "fa") return fa_sessions_not_notifications(inputs)
	if (locale === "sw") return sw_sessions_not_notifications(inputs)
	if (locale === "nl") return nl_sessions_not_notifications(inputs)
	return en_sessions_not_notifications(inputs)
});